























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PhotoViewModel } from "./types";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { Notification } from "@/store/modules/notifications";
import { Action, Getter } from "vuex-class";
import { PhotoTag } from "@/shared/models/photoTag";
import _ from "lodash";

@Component({
  components: {
    RightDrawer,
  },
})
export default class PhotoForm extends Vue {
  @Prop() endpoint?: string;
  @Prop() photo?: PhotoViewModel;

  @Prop({ default: false }) open!: boolean;
  @Prop() callback!: () => any;

  @Prop({ default: false }) simpleForm?: boolean;

  fkey = 0;

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
    }

    if (fresh) {
      this.model = _.cloneDeep(this.photo);
      this.initialPhoto = _.cloneDeep(this.model);
      this.loadPhoto();
    } else {
      this.model = new PhotoViewModel();
      this.initialPhoto = _.cloneDeep(this.model);
    }
  }

  src: any = "";

  model?: PhotoViewModel = new PhotoViewModel();
  initialPhoto?: PhotoViewModel = new PhotoViewModel();
  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  submit() {
    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid"),
        timeout: 5000,
      });

      return;
    }

    const model = {
      photo: this.model,
    };

    if (this.endpoint && this.photo) {
      const tempEndpoint = !this.simpleForm
        ? this.endpoint + "/" + this.photo.id
        : this.endpoint
      Vue.axios.put(tempEndpoint, model).then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Photo.SaveSuccess"),
          timeout: 5000,
        } as Notification);

        this.$emit("update:open", false);
        this.callback();
      });
    }
  }

  loadingPhoto = false;
  loadPhoto() {
    this.loadingPhoto = true;
    this.src = "";

    if (this.simpleForm && this.endpoint) {
      Vue.axios
      .get<PhotoViewModel>(this.endpoint + "/details")
      .then((res) => {
        this.model = res.data;
      });
    }

    if (!this.photo?.id) {
      return;
    }

    const tempEndpoint = !this.simpleForm
      ? this.endpoint + "/" + this.photo.id
      : this.endpoint

    Vue.axios
      .get(tempEndpoint + "?width=920&quality=95", {
        responseType: "blob",
      })
      .then((res) => {
        const reader = new FileReader();
        reader.readAsDataURL(res.data);
        reader.onload = () => {
          this.src = reader.result;
        };
      })
      .catch(() => {
        this.src = require("@/assets/images/no-image-icon-23488.png");
      })
      .finally(() => {
        this.loadingPhoto = false;
      });
  }

  @Action("codebooks/refreshPhotoTags") refreshTags?: () => Promise<void>;
  @Getter("codebooks/photoTags") tags?: PhotoTag[];

  rules = {};
  async created() {
    this.rules = {
      required: (value: any) => !!value || this.$t("Validation.Required"),
    };

    if ((this.tags?.length ?? 0) === 0 && this.refreshTags) {
      await this.refreshTags();
    }
  }
}
